/** Appointment reminders and WhatsApp updates for bookings. Conventions: see `common.ts`. */
const bookingReminders: Record<string, string> = {
  open: 'Reminders',
  title: 'Appointment reminders',
  intro: 'Remind customers of their appointment before it comes round, so fewer forget to turn up.',
  loading: 'Loading your reminder settings…',
  load_error: 'Your reminder settings could not be loaded. Please try again.',
  saved: 'Reminder settings saved',
  save_error: 'The reminder settings could not be saved.',

  hours_before_one: '{count} hour before',
  hours_before_other: '{count} hours before',

  'first.label': 'First reminder',
  'first.off': 'Off - send no reminders',
  'second.label': 'Second reminder',
  'second.none': 'None',
  'second.hint': 'A shorter nudge closer to the time.',
  'second.too_late': 'The second reminder has to come closer to the appointment than the first.',

  channels: 'Send by',
  'email.label': 'Email',
  'email.hint': 'To customers with an email address.',
  'email.edit': 'Edit the reminder email',
  'whatsapp.label': 'WhatsApp',
  'whatsapp.consent': 'Only customers who agreed to WhatsApp updates when booking get them.',
  'whatsapp.static_hint':
    "WhatsApp reminders also need the 'Appointment reminder' automation turned on with an approved template, in WhatsApp → Automations.",
  'whatsapp.checking': 'Checking your WhatsApp automations…',
  'whatsapp.ready': "Ready: the 'Appointment reminder' automation is on, using the template {template}.",
  'whatsapp.off': "WhatsApp reminders will not go out yet: turn on 'Appointment reminder' and pick an approved template.",
  'whatsapp.no_template':
    "WhatsApp reminders will not go out yet: pick an approved template for 'Appointment reminder'.",
  'whatsapp.open_automations': 'Open WhatsApp → Automations',
  no_channel: 'Neither email nor WhatsApp is ticked, so no reminder will be sent.',

  'desk.whatsapp_opt_in': 'Customer agreed to WhatsApp updates',
  'desk.whatsapp_opt_in_hint': 'Confirmations and reminders for this appointment can then go to their phone on WhatsApp.',

  'token_near.label': 'Your turn is near (token queue)',
  'token_near.hint': 'Tell patients on WhatsApp when they are this many tokens away, so they can head back in time. Only patients who agreed to WhatsApp updates get it.',
  'token_near.option_one': '{count} token away',
  'token_near.option_other': '{count} tokens away',

  'detail.whatsapp_agreed': 'WhatsApp updates: agreed',
};

export default bookingReminders;
